<template>
    <div v-if="numPages" class="flex column items-center">
        <q-pagination
                :model-value="modelValue"
                color="primary"
                :max="numPages"
                :max-pages="10"
                :direction-links="directionLinks"
                :boundary-links="boundaryLinks"
                icon-first="fas fa-angle-double-left"
                icon-prev="fas fa-angle-left"
                icon-next="fas fa-angle-right"
                icon-last="fas fa-angle-double-right"
                :size="size"
                @update:model-value="$emit('update:modelValue', $event)"
        />
        <div class="q-mt-sm">Showing {{ start }} - {{ end }} of {{ total }}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaginationMixin } from '@/mixins';

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [PaginationMixin],
  props: {
    directionLinks: {
      type: Boolean,
      default: false,
    },
    boundaryLinks: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
